import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"var(--xrk-color-primary)","margin-top":"16px"} }, " 注：添加人员只能是“已导入项目的人员” ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"20px","margin-top":"15px"} }, " 只能上传xls或xlsx文件 ", -1)

import {
  withDefaults,
  reactive,
  ref,
  computed
} from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseUpload,
  XrkMessage,
  createDialog
} from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import {
  batchAddActivityPeople,
  downloadTemplate,
  againSubmit
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import AddPersonFailTable from './add-person-fail-table.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'batch-add-activity-person',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    activityId: { default: null },
    importType: { default: null }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const store = useProjectDetailStore();

const props = __props;
const emits = __emit;

const projectInfo = computed(() => store.baseData.projectInfo);

const upload = ref(null);

const formData = reactive({
  fileList: []
});
const onCancel = () => {
  props.remove();
};

const excelCode = ref('');

//生成唯一id
function generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

const againSubmitPerson = async (inVO, dataList) => {
  try {
    inVO = JSON.parse(inVO);
  } catch (error) {
    //
  }
  const { data } = await againSubmit({ inVO, dataList });
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: false,
      showFooter: false,
      contentRender: done => {
        return (
          <AddPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
              done();
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></AddPersonFailTable>
        );
      }
    });
    props.remove();
  }
};

const onConfirm = async () => {
  if (formData.fileList.length <= 0) {
    XrkMessage.error('请先上传文件！');
    return;
  }
  excelCode.value = generateUniqueId();
  const inVO = {
    projectId: projectInfo.value.id,
    activityId: props.activityId,
    importType: props.importType,
    excelCode: excelCode.value,
    excelUploadUrl: formData.fileList[0].url,
    excelName: formData.fileList[0].name
  };
  const params = {
    inVO: JSON.stringify(inVO),
    file: formData.fileList[0].raw
  };

  const { data } = await batchAddActivityPeople(params);
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: false,
      showFooter: false,
      contentRender: done => {
        return (
          <AddPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
              done();
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></AddPersonFailTable>
        );
      }
    });
    props.remove();
  }
};
const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
//名单模板下载
function downLoadTempLate() {
  downloadTemplate({ excelGroupCode: 'activity_participants' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "436px",
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "添加人员"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认导入")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(BaseUpload), {
          fileList: formData.fileList,
          "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((formData.fileList) = $event)),
          style: {"width":"400px","display":"inline-block"},
          ref_key: "upload",
          ref: upload,
          listType: "text",
          limit: 1,
          "limit-size": 3,
          accept: ['xls', 'xlsx'],
          httpRequest: httpRequest,
          "auto-upload": true,
          onError: onError,
          btnText: "上传人员名单"
        }, {
          tip: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["fileList"])
      ]),
      _createVNode(_unref(BaseButton), {
        style: {"margin-left":"20px"},
        type: "text",
        icon: _unref(Download),
        onClick: downLoadTempLate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 名单模板下载 ")
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _: 1
  }))
}
}

})